import Vue from 'vue'
import Router from 'vue-router'
import { auth } from '@/auth/index'
import HomePage from '@/components/HomePage.vue'
import Login from '@/components/userAccount/Login.vue'
import Registration from '@/components/userAccount/Registration.vue'
//import PasswordRecovery from '@/components/userAccount/PasswordRecovery.vue'
import ChangePassword from '@/components/userAccount/ChangePassword.vue'
import Profile from '@/components/userAccount/Profile.vue'
import Settings from '@/components/settings/Settings.vue'

//Notification Floder Imports
import Notifications from '@/components/Notification/Notifications.vue'
import Notification from '@/components/Notification/NotificationSingle.vue'

//Dashboard Folder Imports
import Dashboard from '@/components/dashboard/Dashboard.vue'
import DashboardHome from '@/components/dashboard/DashboardHome.vue'

//Navigation Pages Folder Imports
import BudgetData from '@/components/dashboard/navigationPages/BudgetData.vue'
import Extensions from '@/components/dashboard/navigationPages/Extensions.vue'
import MainNav from '@/components/dashboard/navigationPages/MainNav.vue'
import Reminders from '@/components/dashboard/navigationPages/Reminders.vue'


//Account Folder Imports
import ViewAccount from '@/components/account/ViewAccounts.vue'
import AddAccount from '@/components/account/AddAccounts.vue'
import EditAccount from '@/components/account/EditAccounts.vue'

//Income Folder Imports
import ViewIncome from '@/components/income/ViewIncomes.vue'
import AddIncome from '@/components/income/AddIncomes.vue'
import EditIncome from '@/components/income/EditIncomes.vue'

//Expense Folder Imports
import ViewExpense from '@/components/expense/ViewExpenses.vue'
import AddExpense from '@/components/expense/AddExpenses.vue'
import EditExpense from '@/components/expense/EditExpenses.vue'

//Budget Folder Imports
import ViewBudget from '@/components/budget/ViewBudgets.vue'
import AddBudget from '@/components/budget/AddBudgets.vue'
import EditBudget from '@/components/budget/EditBudgets.vue'

//Transaction Folder Imports
import ViewTransaction from '@/components/transaction/ViewTransactions.vue'
import AddTransaction from '@/components/transaction/AddTransaction.vue'
import EditTransaction from '@/components/transaction/EditTransaction.vue'

//Transfer FolderImports
import ViewTransfer from '@/components/transfer/ViewTransfers.vue'
import AddTransfer from '@/components/transfer/AddTransfers.vue'
import EditTransfer from '@/components/transfer/EditTransfers.vue'

//Help Folder Imports
import Help from '@/components/help/help.vue'

//Feedback Folder Imports
import Suggestions from '@/components/Feedback/Suggestions.vue'
import Issues from '@/components/Feedback/Issues.vue'

//Error Page
import Error from '@/Error.vue'

Vue.use(Router)


let router = new Router({
  mode: 'history',
  routes: [
    { path: '/index.html', component: HomePage },
    { path: '/', component: HomePage },

    //User Account Links
    { path: '/login', component: Login },
    { path: '/registration', component: Registration },
    //{ path: '/PasswordRecovery', component: PasswordRecovery },
    { path: '/ChangePassword', component: ChangePassword },

    //Dashboard Links
    {
      path: '/dashboard/', component: Dashboard,
      children:
        [
          // DashboardHome will be rendered inside Dashboard's <router-view>
          // when /Dashboard is matched
          { path: '', redirect: 'home' },
          { path: 'home', component: DashboardHome/*, meta: { requiresAuth: true }*/ },

          //Profile Page
          { path: 'profile', component: Profile },

          //navigation Pages
          { path: 'budgetData', component: BudgetData },
          { path: 'extensions', component: Extensions },
          { path: 'mainNav', component: MainNav },
          { path: 'reminders', component: Reminders },

          //Account Link
          { path: 'account', component: ViewAccount },
          { path: 'addAccount', component: AddAccount },
          { path: 'editAccount/:itemId', component: EditAccount },

          //Income Link
          { path: 'income', component: ViewIncome },
          { path: 'AddIncome', component: AddIncome },
          { path: 'EditIncome/:itemId', component: EditIncome },

          //Expense Link
          { path: 'expense', component: ViewExpense },
          { path: 'addExpense', component: AddExpense },
          { path: 'editExpense/:itemId', component: EditExpense },

          //Budget Link
          { path: 'budget', component: ViewBudget },
          { path: 'addBudget', component: AddBudget },
          { path: 'editBudget/:itemId', component: EditBudget },

          //Transaction Link
          { path: 'transaction', component: ViewTransaction },
          { path: 'addTransaction', component: AddTransaction },
          { path: 'editTransaction/:itemId', component: EditTransaction },

          //Transfer Link
          { path: 'transfer', component: ViewTransfer },
          { path: 'addTransfer', component: AddTransfer },
          { path: 'editTransfer/:itemId', component: EditTransfer },

          //Help Link
          { path: 'help', component: Help },

          //Feedback Link
          { path: 'suggestions', component: Suggestions },
          { path: 'issues', component: Issues },

          //Settings Page
          { path: 'settings/:itemId', component: Settings },

          //Notifications Page
          { path: 'Notifications', component: Notifications },
          { path: 'Notification/:itemId', component: Notification },

        ]
    },

    //Error Page Links
    { path: '/Error', component: Error, name: 'Error' },
    { path: "*", component: Error }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (auth.checkAuth()) {
      next()
    }
    else {
      next({ path: '/login' })
    }
  }
  else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js